import * as React from 'react'
import { Card, Modal } from 'react-bootstrap'
import { Link, graphql } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import { getShopifyImage } from 'gatsby-source-shopify'
import slugify from '@sindresorhus/slugify'
// import SaleRibbon from '../../../icons/sale-ribbon'
import Shipping from '../../../icons/shipping'
import comparePrice from '../../../utils/comparePrice'
import freeShipping from '../../../utils/freeShipping'
import { AddToCart } from '../../cart/AddToCart/AddToCart'
import {
  addToCart,
  gatsbyImageWrapper, // onSaleRibbon,
  productCardBody,
  productCardStyle,
  productDetailsStyle,
  productHeadingStyle,
  productImageStyle,
  productInfo,
  productPrice,
  quickBuy,
  savings,
  shippingIcon,
  strikeThrough,
} from './product-card.module.scss'

export function ProductCard({ product, eager, showAddToCart = false }) {
  let {
    title,
    slug,
    media: [firstImage],
    storefrontImages,
    variants,
    options,
    // collections,
    descriptionHtml,
  } = product

  if (firstImage && Object.prototype.hasOwnProperty.call(firstImage, 'image')) {
    firstImage = firstImage.image
  }

  const defaultImageHeight = 200
  const defaultImageWidth = 200
  let storefrontImageData = {}
  if (storefrontImages) {
    const storefrontImage = storefrontImages.edges[0].node
    try {
      storefrontImageData = getShopifyImage({
        image: storefrontImage,
        layout: 'fixed',
        width: defaultImageWidth,
        height: defaultImageHeight,
      })
    } catch (e) {
      console.error(e)
    }
  }

  const [show, setShow] = React.useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  const [quantity, setQuantity] = React.useState(1)
  const [selectedVariant, setSelectedVariant] = React.useState(variants[0])
  const handleOptionChange = (event) => {
    const value = event.target.value

    if (value === '') {
      return
    }

    const updatedSelectedVariant = variants.find((val) => {
      const selectedOptions = val.selectedOptions.find(
        (opt) => opt.name === 'Color' && opt.value === value,
      )
      return selectedOptions != null
    })

    setSelectedVariant(updatedSelectedVariant)
  }

  const hasImage =
    firstImage || Object.getOwnPropertyNames(storefrontImageData || {}).length

  // const price = formatPrice(
  //   priceRangeV2.minVariantPrice.currencyCode,
  //   priceRangeV2.minVariantPrice.amount
  // )

  const sqftPrice =
    product && product.variants && product.variants[0]
      ? comparePrice(product.metafields, product.variants[0])
      : null

  const FreeShipImg =
    product && Array.isArray(product.variants) ? freeShipping(product) : null

  // const Bloatprice = formatPrice(
  //   priceRangeV2.minVariantPrice.currencyCode,
  //   product && product.variants ? sqftPrice.comparePriceSqft : null
  // )

  // const showRibbon = collections?.reduce(
  //   (prev, currentValue) => currentValue.title === 'Featured Deals' || prev,
  //   false,
  // )

  const colorPicker = options?.find((x) => x.name === 'Color')

  const overrideLinkClick = (event) => {
    event.preventDefault()
    handleShow()
  }

  return (
    <Card className={`m-auto ${productCardBody} ${showAddToCart && quickBuy}`}>
      {/* {showRibbon && (
        <div className={onSaleRibbon}>
          <SaleRibbon />
        </div>
      )} */}
      <Link
        className={productCardStyle}
        to={slug ? slug : `/products/${slugify(product.handle)}`}
        aria-label={`View ${title} product page`}
        onClick={showAddToCart ? overrideLinkClick : null}
      >
        {hasImage ? (
          <div className={productImageStyle} data-name='product-image-box'>
            <GatsbyImage
              className={`h-100 ${gatsbyImageWrapper}`}
              alt={firstImage?.altText ?? title}
              image={firstImage?.gatsbyImageData ?? storefrontImageData}
              loading={eager ? 'eager' : 'lazy'}
              objectFit='cover'
            />
          </div>
        ) : (
          <div
            style={{ height: defaultImageHeight, width: defaultImageWidth }}
          />
        )}
      </Link>
      {sqftPrice && product ? (
        <Card.Body className={productDetailsStyle}>
          <Link
            className={productCardStyle}
            to={slug ? slug : `/products/${slugify(product.handle)}`}
            onClick={showAddToCart ? overrideLinkClick : null}
          >
            <Card.Title className={productHeadingStyle}>{title}</Card.Title>
            <div className={strikeThrough}>
              ${' '}
              {sqftPrice.comparePriceSqft
                ? sqftPrice.comparePriceSqft + ' /Sqft'
                : sqftPrice.comparePrice}
            </div>
            <div className={productPrice}>
              ${' '}
              {sqftPrice.priceSqft
                ? sqftPrice.priceSqft + ' /Sqft'
                : sqftPrice.price.toFixed(2)}
            </div>
            {showAddToCart && (
              <div className={`${productPrice} ${productInfo}`}>
                Product info
              </div>
            )}
            {/* {FreeShipImg && (
              <div className={shippingIcon}>
                <Shipping></Shipping>
              </div>
            )} */}
          </Link>
          {showAddToCart ? (
            <>
              <div className={`d-flex ${addToCart}`}>
                {colorPicker && (
                  <select
                    aria-label='Variants'
                    onChange={(event) => handleOptionChange(event)}
                    className='w-100 my-3 border px-2'
                    // style={{width: "60px"}}
                  >
                    {colorPicker.values.map((value) => (
                      <option
                        value={value}
                        key={`${colorPicker.name}-${value}`}
                      >
                        {value}
                      </option>
                    ))}
                  </select>
                )}
                <input
                  className='my-3 border px-2 text-center'
                  aria-label='Quantity'
                  type='number'
                  value={quantity}
                  onChange={(event) => setQuantity(event.currentTarget?.value)}
                  min='1'
                  max='20'
                />
                <AddToCart
                  variants={[
                    {
                      id: selectedVariant.storefrontId,
                      quantity: quantity,
                      available: selectedVariant.availableForSale,
                    },
                  ]}
                />
              </div>
              <Modal
                show={show}
                onHide={handleClose}
                dialogClassName='description-modal'
              >
                <div
                  style={{
                    textAlign: 'right',
                    paddingTop: '1.1rem',
                    paddingRight: '1.5rem',
                  }}
                >
                  <button
                    onClick={() => setShow(false)}
                    type='button'
                    className='btn-close'
                    aria-label='Close'
                  ></button>
                </div>
                <Modal.Body style={{ padding: '0 5rem' }}>
                  <h3>{title}</h3>
                  <h4>Product details</h4>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: descriptionHtml,
                    }}
                  />
                </Modal.Body>
              </Modal>
            </>
          ) : (
            <>
              {/* <div className={`position-absolute ` + savings}>25% Off</div> */}
            </>
          )}
        </Card.Body>
      ) : null}
    </Card>
  )
}

export const query = graphql`
  fragment ProductCard on ShopifyProduct {
    id
    title
    slug: gatsbyPath(filePath: "/products/{ShopifyProduct.handle}")
    media {
      ... on ShopifyMediaImage {
        id
        image {
          altText
          gatsbyImageData(aspectRatio: 1, width: 640)
        }
      }
    }
    variants {
      price
      metafields {
        key
        value
      }
    }
    metafields {
      key
      value
    }
    priceRangeV2 {
      minVariantPrice {
        amount
        currencyCode
      }
    }
  }
`
